import { cx } from '@linaria/core';
import { checkboxMediaInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useUpdateInputMutation } from '../../../../state/mutations/update-input.js';
import { CircledAudioPlayer } from '../../../atom.audio/_audio-player.circled.js';
import { useTaskContext } from '../../context.js';
import { useInputState } from '../../hook.use-input-state.js';
import { TextBox } from '../atom.text-box/_text-box.js';
import { wrapper, box, audio } from './input.text.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TextInput(props) {
  const context = useTaskContext();
  const update = useUpdateInputMutation();
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => checkboxMediaInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const onChange = () => {
    update(props.taskEntryKey, props.node.id, {
      type: "checkbox-media",
      markedAsCorrectAnswer: !inputEntry?.markedAsCorrectAnswer
    });
  };
  const baseState = useInputState(props.node, inputEntry);
  const state = (() => {
    if (baseState === "incorrect" && !inputEntry?.markedAsCorrectAnswer && props.node.correctAnswer) {
      return "should-have";
    }
    return baseState;
  })();
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsx(TextBox, {
      className: cx(box, props.node.audioSrc && "hasAudio"),
      checked: !!inputEntry?.markedAsCorrectAnswer,
      state: state,
      onChange: onChange,
      orientation: props.orientation,
      theme: "squared",
      children: /*#__PURE__*/jsx("span", {
        children: props.node.text
      })
    }), props.node.audioSrc && /*#__PURE__*/jsx(CircledAudioPlayer, {
      className: cx(audio, context === "facit" && state === "readonly" && "readonly"),
      src: props.node.audioSrc,
      size: "small"
    })]
  });
}

export { TextInput };
//# sourceMappingURL=input.text.js.map
